import * as React from 'react';
import { doPost } from 'sos-eservice-common/js/services/fetch.service';
import EventService from '../CalculationComponents/calculationComponents.eventservice';
import { initializeAutosave } from '../../services/autosave.service';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import {
  getErrorBodyApiErrorOnSend,
  getErrorBodyApiErrorOnSave,
  getErrorBodyApiErrorOnSaveClose,
  getErrorBodyJwtTokenTimeout,
  getErrorBodyVipSPSessionTimeout,
} from 'sos-eservice-common/js/config/dialogueErrorBodies';
import { ALL_MANDATORY } from '../CalculationComponents/calculationComponents.errorMessages';
import Console from 'sos-common/js/utils/console.log';

export interface StatsbidragSubmitActionProps {
  formId: string;
  caseId: string;
  foretradareId: string;
  organizationPage: string;
  isRekvisition: boolean;
  type: string;
}

export interface StatsbidragSubmitActionState {
  action: string;
}

const API_ENDPOINT_STATSBIDRAG = '/_api/sbgansokan';
const API_ENDPOINT_REKVISITION = '/_api/rekansokan';
export const SAVE = 'SAVE';
export const SAVE_AND_CLOSE = 'SAVE_AND_CLOSE';
export const SEND = 'SEND';
export const AUTOSAVE = 'AUTOSAVE';
export const POST_ERROR = 'POST_ERROR';

/**
 * Listens events and handles the operations for save, save & close, send.
 * Initializes autosave after component is mount.
 */
export class StatsbidragSubmitAction extends React.Component<
  StatsbidragSubmitActionProps,
  StatsbidragSubmitActionState
> {
  private _form: HTMLFormElement;
  private API_ENDPOINT: string;
  constructor(props: StatsbidragSubmitActionProps) {
    super(props);
    if (props.isRekvisition) {
      this.API_ENDPOINT = API_ENDPOINT_REKVISITION;
    } else {
      this.API_ENDPOINT = API_ENDPOINT_STATSBIDRAG;
    }
    this.state = {
      action: '',
    };
  }

  componentDidMount = () => {
    // If preview, simply disable this entire component by returning here.
    if (this.props.type === 'Preview') return;

    this._form = document.getElementById(this.props.formId) as HTMLFormElement;
    initializeAutosave(this._form);
    EventService.subscribe(`form-submit-action`, (e: CustomEvent) => {
      this.setState(
        {
          action: e.detail,
        },
        () => {
          this.doAction();
        }
      );
    });
  };

  doAction = () => {
    const { caseId, foretradareId } = this.props;
    const { action } = this.state;
    let suffix: string;

    switch (action) {
      case SAVE:
        suffix = SAVE;
        break;
      case SAVE_AND_CLOSE:
        suffix = SAVE;
        break;
      case AUTOSAVE:
        suffix = SAVE;
        break;
      case SEND:
        suffix = SEND;
        break;
    }

    let formData = new FormData(this._form);
    formData.append('__actFid', foretradareId);

    doPost<string>(`${this.API_ENDPOINT}/${suffix}?id=${caseId}`, formData).then((response) => {
      // show dialogue letting user know something went wrong.
      if (response instanceof ResponseError) {
        this.fireDialogueError(response, action);
        EventService.fire(POST_ERROR, null);
      } else {
        switch (action) {
          case SAVE:
            EventService.fire('SHOW_MESSAGEBAR', null);
            break;
          case SAVE_AND_CLOSE:
            EventService.fire('SHOW_MESSAGEBAR', null);
            window.location.href = response;
            break;
          case AUTOSAVE:
            break;
          case SEND:
            window.location.href = response;
            break;
        }
      }
    });
  };

  /**
   * Shows either a failure or a success message based on returned status code.
   * In case of session error; backend returns 401.1 if session times out and 401.2 if JWT token times out.
   * The method fires an event to show a dialouge with the correct body.
   */
  fireDialogueError = (error: ResponseError, action: string) => {
    if (error.body && error.body.detailCode) {
      switch (error.body.detailCode) {
        // SESSION ERROR
        case '401.1':
          // VIP (SP) SESSION TIMED OUT
          EventService.fire('dialogue-error', { detail: getErrorBodyVipSPSessionTimeout(error.body.redirectUri) });
          break;
        case '401.2':
          // JWT TOKEN TIMED OUT
          EventService.fire('dialogue-error', { detail: getErrorBodyJwtTokenTimeout(error.body.redirectUri) });
          break;
      }
    } else {
      switch (action) {
        case SAVE:
          EventService.fire('dialogue-error', {
            detail: getErrorBodyApiErrorOnSave(this.props.organizationPage, error.body.errorMessage),
          });
          break;
        case SAVE_AND_CLOSE:
          EventService.fire('dialogue-error', {
            detail: getErrorBodyApiErrorOnSaveClose(this.props.organizationPage, error.body.errorMessage),
          });
          break;
        case AUTOSAVE:
          break;
        case SEND:
          EventService.fire('dialogue-error', { detail: getErrorBodyApiErrorOnSend(error.body.errorMessage) });
          break;
      }
    }
  };

  /**
   * TODO: We might not need to send this anymore since we have different endpoints.
   */
  public render() {
    return <input type="hidden" value={this.state.action} name="STB_SUBMIT_ACTION" />;
  }
}
